import fetcher from '@utils/fetcher';

const ListingServices = {
    getCategoryID: (slug) => fetcher(`v1/meta/categories?slug=${slug}`),
    getMenuItems: () => fetcher('v1/menu'),
    getProductCategories: () => fetcher('v1/category'),
    getProducts: ({
        pageParam,
        q = '',
        keyword = '',
        categoryID = '',
        order = 'newProduct',
        discounted = false,
        priceMin = '0',
        priceMax = '',
        size = '',
        colour = '',
        categories = '',
        pageSize = 24,
        currency = 'TRY',
    }) =>
        fetcher(
            `v2/product?page=${pageParam}&keyword=${keyword}&q=${
                q + categories
            }&categoryId=${categoryID}&sort=${order}&discounted=${discounted}&soldOut=&priceMin=${priceMin}&priceMax=${priceMax}&currency=${currency}&size=${size}&colour=${colour}&pageSize=${pageSize}`,
        ),
};

export default ListingServices;
